module.exports = __webpack_public_path__ + "static/media/poster11.3c9e518a.png";